<template>
  <b-card>
    <DeleteRewardModal
      :reward="toBeDeletedReward"
      @deleted="getRewards"
    />
    <base-overlay :show="fetching">
      <b-row>
        <b-col md="4">
          <b-button
            v-if="$can('write', 'rewards')"
            class="mb-2 mr-2"
            variant="primary"
            to="/create-reward"
          >
            Add Reward
          </b-button>
        </b-col>
      </b-row>
      <b-table
        :items="rewardsList"
        responsive
        :fields="tableColumns"
        show-empty
        empty-text="No matching rewards found"
      >
        <template #cell(actions)="data">
          <b-dropdown
            variant="link"
            no-caret
          >
            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>
            <b-dropdown-item
              v-if="$can('write', 'rewards')"
              :to="{
                name: 'edit-reward',
                params: { id: data.item.id },
              }"
            >
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">Edit</span>
            </b-dropdown-item>
            <b-dropdown-item
              v-if="$can('delete', 'rewards')"
              @click="deletePopupHandler(data.item)"
            >
              <feather-icon icon="TrashIcon" />
              <span class="align-middle ml-50">Delete</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>
      </b-table>
      <base-pagination
        v-model="queryParams.page"
        :total="totalRewards"
        @input="getRewards"
        @new-per-page="queryParams.perPage = $event"
      />
    </base-overlay>
  </b-card>
</template>

<script>
import {
  BTable, BButton, BCard, BDropdown, BDropdownItem, BRow, BCol,
} from 'bootstrap-vue'
import useRegisterStoreModule from '@/hooks/useRegisterStoreModule'
import store from '../store'
import useRewardsList from '../hooks/useRewardsList'
import DeleteRewardModal from '../components/DeleteRewardModal.vue'
import BasePagination from '@/UI/BasePagination.vue'

export default {
  components: {
    BTable,
    BButton,
    BCard,
    BDropdown,
    BasePagination,
    BDropdownItem,
    DeleteRewardModal,
    BRow,
    BCol,
  },
  setup(_, ctx) {
    useRegisterStoreModule('rewards', store)
    return {
      ...useRewardsList(ctx, 'DRIVER'),
    }
  },
}
</script>

  <style>

  </style>
